import React from "react";
import "../Home.css";

function Get() {
  return (
    <div className="Get">
      <section className="Get-Container">
        <p>Get Involved</p>
        <h2>BECOME A <span>BLOOD DONOR</span></h2>
        <p>
          In every 3 seconds someone out there needs blood transfusion .<br /> Donate
          Blood and Help save a life.
        </p>
        <a href=" " id="Get-Link"> Sign Up</a>
      </section>
    </div>
  );
}

export default Get;
